
// * ========================================================================
// * Chart tooltips
// * ========================================================================

import moment from 'moment';

const tooltips = (function(){
    /**
     * Initialize
     */
    function init() {
        // Clear tooltips on window resize
        window.addEventListener('resize', function(){
            const tooltipElem = document.querySelectorAll('.chart-tooltip');
            for (const elem of tooltipElem) {
                elem.classList.remove('tooltip-visible');
                elem.style.left = 'auto';
                elem.style.top = 'auto';
                elem.innerHTML = '';
            }
        });
    }

    /*
    * Custom chart tooltip
    */
    function customTooltip(data, elementId, options) {
        const {
            highlightFirstIndex,
            hideHighlight,
            highlightSecondIndex,
            customHeading
        } = options;

        const tooltipModel = data.tooltip;
        const bodyWidth = document.body.clientWidth;

        // Tooltip Element
        const tooltipEl = document.getElementById(elementId);

        // Hide if no tooltip
        if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            tooltipEl.classList.remove('tooltip-visible');
            return;
        }

        // Set Text
        if (tooltipModel.body) {
            const titleLines = tooltipModel.title || [];
            const bodyLines = tooltipModel.body.map(function(item) {
                return item.lines;
            });

            if (!bodyLines.length) {
                // Hide
                tooltipEl.style.opacity = 0;
                tooltipEl.classList.remove('tooltip-visible');
                return;
            }
            const dayNames = ['Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai', 'Sunnuntai'];

            let innerHtml = '';
            titleLines.forEach(function(title) { // "Jan 18, 2021, 12:00:00 am
                const date = moment(title, 'MMM D, YYYY, hh:mm:ss a');
                if (customHeading === 'week') {
                    const dateString = date.format('W / YYYY');
                    innerHtml += '<p class="tooltip-title">Viikko ' + dateString + '</p>';
                } else if (customHeading === 'month') {
                    const dateString = date.format('MMM / YYYY');
                    innerHtml += '<p class="tooltip-title">' + dateString + '</p>';
                } else if (customHeading === 'as-is') {
                    innerHtml += '<p class="tooltip-title">' + title + '</p>';
                } else {
                    const dayOfWeek = parseInt(date.format('e'));
                    const dateString = date.format('D.M.YYYY');
                    innerHtml += '<p class="tooltip-title">' + dayNames[dayOfWeek] + ' ' + dateString + '</p>';
                }
            });
            innerHtml += '<div class="tooltip-data"><table><tbody>';

            const highlight = highlightFirstIndex && tooltipModel.dataPoints.length && tooltipModel.dataPoints[0].datasetIndex === 0;
            const highlight2 = highlightSecondIndex && tooltipModel.dataPoints.length && tooltipModel.dataPoints[1].datasetIndex === 1;
            bodyLines.forEach(function(body, i) {
                const isHighlight = (highlight && i === 0) || (highlight2 && i === 1);
                const highlightClass = isHighlight ? 'tooltip-highlight': '';
                if (body.length) {
                    var colors = tooltipModel.labelColors[i];
                    var span = hideHighlight && isHighlight ? '' : '<span class="tooltip-color-label" style="background:' + colors.backgroundColor + '"></span>';
                    innerHtml += '<tr class="'+highlightClass+'"><td>' + span + body + '</td></tr>';
                }
            });
            innerHtml += '</tbody></table></div>';

            tooltipEl.innerHTML = innerHtml;
        }
        // Set styles for font
        tooltipEl.style.fontFamily = '"Helvetica Neue", "Helvetica", "Arial", sans-serif';
        tooltipEl.style.fontSize = '12px';
        tooltipEl.style.fontStyle = 'normal';
        tooltipEl.style.padding = '6px 6px';
        tooltipEl.style.pointerEvents = 'none';

        // Set tooltip position
        const position = data.chart.canvas.getBoundingClientRect();
        const tooltipRect = tooltipEl.getBoundingClientRect();
        let tipX = (position.left + window.pageXOffset + tooltipModel.caretX) - (tooltipRect.width / 2);

        const tooltipPosRight = tipX + tooltipRect.width;

        // Corrections if out of window
        if (tooltipPosRight > bodyWidth) { // Out from right
            const movePos = tooltipPosRight - bodyWidth;
            tipX = tipX - (movePos + 5);
        }

        tooltipEl.style.left = tipX + 'px';
        tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
        tooltipEl.classList.add('tooltip-visible');
    }

    return {
        init: init,
        create: customTooltip
    }

})();

export default tooltips;
